export * from './TagServiceAdapter'
